import { connect } from 'react-redux';

import { selectedLocale } from '../../../../store/locale/action';
import AcceptInvitationComponent from './component';

import { injectIntl } from 'react-intl';

const AcceptTeamInvitation = connect(
  state => ({
    isAuthenticated: state.auth.isAuthenticated,
    initialAuthDone: state.auth.initialAuthDone
  }),
  {
    selectedLocale
  }
)(AcceptInvitationComponent);

export default injectIntl(AcceptTeamInvitation);
